module.exports = "/images/_/_/_/_/build/resources/js/src/assets/images/banner/banner-12.jpg";